import Misc from './misc';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';

class sliderContentLeft {
  constructor() {
    this.sliderWrapper = document.querySelector('.slider-wrapper');
    this.sliderTrigger = document.querySelector('.slider-content--trigger');
    this.sliderInner = document.querySelector('.slider-content--inner');
    this.handleSlider = this.handleSlider.bind(this);
    this.handleOnResize = this.handleOnResize.bind(this);

    this.sliderTrigger.addEventListener('click', this.handleSlider);
    window.addEventListener('resize', this.handleOnResize);
  }

  handleSlider(event) {
    event.preventDefault();
    if (!this.sliderWrapper.classList.contains('on-open')) {
      this.openSlider();
    } else {
      this.closeSlider();
    }
  }

  openSlider() {
    this.sliderInner.style.setProperty(
      'height',
      `${Misc.getViewport().height}px`
    );
    this.sliderWrapper.classList.add('on-open');
    disableBodyScroll(this.sliderInner);
  }

  closeSlider() {
    this.sliderWrapper.classList.remove('on-open');
    // this.sliderInner.style.removeProperty('height');
    enableBodyScroll(this.sliderInner);
    clearAllBodyScrollLocks();
    localStorage.setItem('sliderFirstOpen', false);
  }
  handleOnResize() {
    if (this.sliderWrapper.classList.contains('on-open')) {
      this.sliderInner.style.setProperty(
        'height',
        `${Misc.getViewport().height}px`
      );
    }
  }
}

if (document.querySelector('.slider-wrapper')) {
  const sliderContentLeftInstance = new sliderContentLeft();
}